import { styled } from 'styled-components';

export const Pipes = styled.div`
  display: flex;
  flex-direction: column;

  color: #fff;
  text-align: center;
  text-transform: uppercase;
`;

export const StageDescription = styled.h1`
  font-size: 48px;
  font-weight: 600;
  text-align: left;
  margin-bottom: 72px;
`;

export const PuzzleObjective = styled.span`
  margin-top: 72px;

  font-size: 32px;
  font-weight: 600;
  text-transform: none;
  text-align: right;
`;